module.exports = __webpack_public_path__ + "img/energy-shield-mk2-equipment.1192716b.png";